import { Grid } from '@mui/material';
import { styled } from '@mui/material/styles';

import { Box, BoxProps } from '../../../components/atoms/Box';
import { Button } from '../../../components/atoms/Button';
import { SelectMenu } from '../../../components/atoms/SelectMenu';
import { Typography } from '../../../components/atoms/Typography';

export const ServiceTypography = styled(Typography)`
  padding-bottom: 10px;
`;

export const ServiceBox = styled(Box)`
  width: 100%;
  padding: 10px;
  border: 2px solid #eeeeee;
  border-radius: 5px;
  background-color: #ffffff;
  box-sizing: border-box;
`;

export const StyledSelectMenu = styled(SelectMenu)`
  width: 100%;
`;

export const StyledSelectMenuSmall = styled(SelectMenu)`
  width: 50%;
`;

export const StyledListItem = styled('li')`
  border-bottom: 1px solid lightgray;
`;

export const StyledBox = styled(Box)((props: BoxProps & { heighlightBackground?: boolean }) => `
  background-color: ${props.heighlightBackground ? 'rgba(255, 99, 71, 0.1)' : 'transparent'};`
);

export const SwitchGrid = styled(Grid)`
  justify-content: right;
  align-items: center;
`;

export const ModeSwitchGrid = styled(Grid)`
  margin-left: 30px;
  padding-bottom: 10px;
`;

export const StructureEditContainer = styled(Box)`
  margin: 0 auto;
  margin-top: 5vh;
  position: relative;
  width: 80%;
  max-width: 80%;
  max-height: 80vh;
  overflow-y: auto;
  border: 1px solid #000;
  background-color: white;
  border-radius: 10px;
  padding: 10px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
`;

export const StructureCreateContainer = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 1px solid #000;
  background-color: white;
  border-radius: 10px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
`;

export const ContentBox = styled('div')`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const StyledEditLocationBox = styled(Box)`
  width: 100%;
  display: flex;
`;

export const StyledButton = styled(Button)`
  width: 100%;
  height: 55px; /* optional, to match text field height */
  line-height: normal;
`;

export const InteractionsContainer = styled(Grid)`
  margin-top: 10px;
  margin-bottom: 20px;
  max-height: calc(100vh - 600px);
  overflow-y: auto;
`;